import { gql } from '@apollo/client';

export const fetchContactsForEntitlement = gql`
  query fetchContactsForEntitlement($id: String, $searchOptions: ConnectionSearchOptions) {
    entitlementDetails(id: $id) {
      id
      baseProduct
      users(searchOptions: $searchOptions) {
        totalCount
        nodes {
          displayName
          primaryEmail
          roles
          lastActive
          atlassianAccount {
            id
          }
        }
      }
      siteAdmins {
        totalCount
        nodes {
          displayName
          primaryEmail
          roles
          lastActive
          atlassianAccount {
            id
          }
        }
      }
    }
  }
`;
